// Mock implementation of LIFF SDK
const mockLiff = {
    id: "mock-liff-id",
    ready: Promise.resolve(),
    init: () => {
        console.log("[MockLIFF] Initialized");
        return Promise.resolve();
    },
    getOS: () => "web",
    getLanguage: () => "ja",
    getVersion: () => "2.0.0",
    isInClient: () => false,
    isLoggedIn: () => {
        console.log("[MockLIFF] isLoggedIn called -> true");
        return true;
    },
    login: () => {
        console.log("[MockLIFF] login called");
        return Promise.resolve();
    },
    logout: () => {
        console.log("[MockLIFF] logout called");
    },
    getIDToken: () => {
        console.log("[MockLIFF] getIDToken called -> mock_token");
        return "mock_token";
    },
    getDecodedIDToken: () => {
        console.log("[MockLIFF] getDecodedIDToken called");
        return {
            name: "Mock User",
            email: "mock@example.com",
            picture: "https://via.placeholder.com/150",
            sub: "mock_user_id",
        };
    },
    getContext: () => {
        return {
            type: "external",
            viewType: "full",
            userId: "mock_user_id",
        };
    },
    getProfile: () => {
        return Promise.resolve({
            userId: "mock_user_id",
            displayName: "Mock User",
            pictureUrl: "https://via.placeholder.com/150",
            statusMessage: "Hello, Mock World!",
        });
    },
    closeWindow: () => {
        console.log("[MockLIFF] closeWindow called");
    },
    openWindow: (params) => {
        console.log("[MockLIFF] openWindow called", params);
        window.open(params.url, "_blank");
    },
};

export default mockLiff;
